import { render } from "./home.vue?vue&type=template&id=4cba2488&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=4cba2488&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-4cba2488"

export default script